import { Injectable } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import { TranslateService } from '../../../api/translate.service';

import {
  fieldAddressLine1Col,
  fieldAddressLine2Col,
  fieldAgileSpaceDetailsCol,
  fieldApprovedByCol,
  fieldAssetPortfolioTypeCol,
  fieldBillingOfficeCol,
  fieldBuildingNameCol,
  fieldCarParkSpacesCol,
  fieldCompanyTypeCol,
  fieldConfidentialityStatusCol,
  fieldCounterPartyCol,
  fieldCounterPartyEquityCol,
  fieldCounterPartyVehicleCol,
  fieldCountryCol,
  fieldCreatedByCol,
  fieldCurrencyCol,
  fieldCustomerIdCol,
  fieldCustomerNameCol,
  fieldDateCol,
  fieldDedicatedClientNameCol,
  fieldDistrictCol,
  fieldERVCol,
  fieldExecutionDateCol,
  fieldGridIdCol,
  fieldGstRateCol,
  fieldGwsEntityLocationCol,
  fieldIdCol,
  fieldInvestmentProfileCol,
  fieldInvoiceFeeBasisCol,
  fieldInvoiceHeaderCol,
  fieldInvoiceIdCol,
  fieldInvoiceTypeCol,
  fieldIpMetroCol,
  fieldIsGwsEntityCol,
  fieldLandAreaMeasureCol,
  fieldLandCol,
  fieldLocalityCol,
  fieldMiqIdCol,
  fieldMoneyInTrustCol,
  fieldNetOperatingIncomeCol,
  fieldNetYieldCol,
  fieldOccupancyPercentageCol,
  fieldOppNumberCol,
  fieldOpportunityCol,
  fieldOpportunityInstallmentCol,
  fieldOpportunitySourceCol,
  fieldOtherIncomeCol,
  fieldPaymentTermsCol,
  fieldPlaceOfSupplyCol,
  fieldPostcodeCol,
  fieldPrimaryEmployeeFunctionalUnitCol,
  fieldPrimaryEmployeeFunctionalUnitIdCol,
  fieldPrimaryEmployeeIdCol,
  fieldPrimaryEmployeeManagingOfficeCol,
  fieldPrimaryEmployeeManagingOfficeIdCol,
  fieldPrimaryEmployeeNameCol,
  fieldPropertyAreaCol,
  fieldPropertyBaseIdCol,
  fieldPropertyManagedCol,
  fieldPropertySubtypeCol,
  fieldPropertyTypeCol,
  fieldPurchaseOrderCol,
  fieldPurchasePriceCol,
  fieldRegionCol,
  fieldRepCustEquityCol,
  fieldRepCustVehicleCol,
  fieldRepRolCol,
  fieldResidentialUnitsCol,
  fieldRoomsCol,
  fieldSellerNameCol,
  fieldSgstUtgstPercentageCol,
  fieldSizeAreaMeasureCol,
  fieldSubFeeTypeCol,
  fieldSubmittedByCol,
  fieldSuburbCol,
  fieldTeamCol,
  fieldTenancyCol,
  fieldTenureCol,
  fieldTotalInvoiceAmountCol,
  fieldTransactionTypeCol,
  fieldTransSubtypeCol,
  fieldWaleCol,
  fieldIsDataCenterDealCol,
  fieldPropertyTypeSpaceLabelCol,
} from '../../../utils/ag-grid/column-defs';

@Injectable({
  providedIn: 'root'
})
export class SaleConsultingPropertyCustomerReportService {

  constructor(private readonly translateService: TranslateService) { }

  getHeaders(settings: { middle: any, left: any, right: any }) {
    return [
      {
        header: this.translateService.getTranslation('FINISHLINE_ID'),
        key: 'finishline_id',
        width: 7,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('INVOICE_ID'),
        key: 'invoice_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('TRANSACTION_TYPE'),
        key: 'transaction_type',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('INVOICE_DT'),
        key: 'invoice_date',
        width: 20,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('INVOICE_TYPE'),
        key: 'invoice_type',
        width: 10,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('TEAM_ID'),
        key: 'team',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('CURRENCY'),
        key: 'currency',
        width: 20,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('OPPORTUNITY_NO'),
        key: 'opportunity_number',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('OPPORTUNITY_ID'),
        key: 'opportunity',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('OPPORTUNITY_INSTALLMENT_ID'),
        key: 'opportunity_installment_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('OPPORTUNITY_SOURCE'),
        key: 'opportunity_source',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('TRANSACTION_SUBTYPE'),
        key: 'transaction_subtype',
        width: 20,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('EXECUTION_DATE'),
        key: 'execution_date',
        width: 20,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('ASSET_TYPE'),
        key: 'asset_type',
        width: 20,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('MIQ_PROPERTY_ID'),
        key: 'miq_property_id',
        width: 20,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PROPERTY_GRID_ID'),
        key: 'grid_id',
        width: 20,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('BUILDING_NAME'),
        key: 'building_name',
        width: 20,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('ADDRESS_LINE1'),
        key: 'address_line1',
        width: 10,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('ADDRESS_LINE2'),
        key: 'address_line2',
        width: 20,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('POSTAL_CODE'),
        key: 'postal_code',
        width: 16,
        style: { ...settings.left },
      },
      {
        header: this.translateService.getTranslation('SUBURB'),
        key: 'suburb',
        width: 16,
        style: { ...settings.left },
      },
      {
        header: this.translateService.getTranslation('DISTRICT'),
        key: 'district',
        width: 16,
        style: { ...settings.left },
      },
      {
        header: this.translateService.getTranslation('LOCALITY'),
        key: 'locality',
        width: 16,
        style: { ...settings.left },
      },
      {
        header: this.translateService.getTranslation('REGION'),
        key: 'region',
        width: 16,
        style: { ...settings.left },
      },
      {
        header: this.translateService.getTranslation('COUNTRY'),
        key: 'country',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('AGILE_SPACE_DETAILS'),
        key: 'agile_space_details',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PROPERTY_TYPE'),
        key: 'property_type',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PROPERTY_SUBTYPE'),
        key: 'property_subtype',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PROPERTY_TYPE_SPACE'),
        key: 'property_type_space',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PROPERTY_AREA'),
        key: 'property_area',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('SIZE_AREA_MEASURE'),
        key: 'size_area_measure',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('RESIDENTIAL_UNITS'),
        key: 'units',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('ROOMS'),
        key: 'rooms',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('LAND'),
        key: 'land',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('LAND_AREA_MEASURE'),
        key: 'land_area_measure',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('CALCULATION_METRIC_RACKS'),
        key: 'racks',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('CALCULATION_METRIC_MEGAWATTS'),
        key: 'megawatts',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('CALCULATION_METRIC_KILOWATTS'),
        key: 'kilowatts',
        width: 20,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('CAR_SPACES'),
        key: 'car_park_spaces',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('INVESTMENT_PROFILE'),
        key: 'investment_portfolio',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('TENURE'),
        key: 'tenure',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('TENANCY'),
        key: 'tenancy',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('OCCUPANCY_PERCENTAGE'),
        key: 'occupancy_percentage',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('WALE'),
        key: 'wale',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('NET_OPERATING_INCOME'),
        key: 'net_operating_income',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PURCHASE_PRICE').toUpperCase(),
        key: 'purchase_price',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('NET_YIELD').toUpperCase(),
        key: 'net_yield',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('ERV_FULLY_OCCUPIED'),
        key: 'gross_revenue_erv',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('MANAGED_BY_CBRE'),
        key: 'managed_by_cbre',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_ID'),
        key: 'primary_employee_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_NAME'),
        key: 'primary_employee_name',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_FU_ID'),
        key: 'primary_employee_functional_unit_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_FU_DESC'),
        key: 'primary_employee_functional_unit',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_MO_ID'),
        key: 'primary_employee_managing_office_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PRIMARY_EMPLOYEE_MO_DESC'),
        key: 'primary_employee_managing_office',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('REP_ROLE'),
        key: 'representation_role',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('CUSTOMER_ID'),
        key: 'customer_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('CUSTOMER_NAME'),
        key: 'customer_name',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('COMPANY_TYPE'),
        key: 'company_type',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('DEDICATED_CLIENT_NAME'),
        key: 'dedicated_client_name',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('REPRESENTED_FUNDING_VEHICLE'),
        key: 'repped_customer_vehicle_name',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('REPRESENTED_EQUITY_SOURCE'),
        key: 'repped_customer_source_of_equity',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('COUNTER_PARTY_NAME'),
        key: 'counter_party_company_name',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('COUNTER_PARTY_FUNDING_VEHICLE'),
        key: 'counter_party_vehicle_name',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('COUNTER_PARTY_EQUITY_SOURCE'),
        key: 'counter_party_source_of_equity',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('CUSTOMER_ID'),
        key: 'bill_to_customer_id',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('BILL_TO_CUST'),
        key: 'bill_to_customer_name',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('COMPANY_TYPE'),
        key: 'bill_to_company_type',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('DEDICATED_CLIENT_NAME'),
        key: 'bill_to_dedicated_client_name',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PURCHASE_ORDER'),
        key: 'purchase_order_number',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('MONEY_IN_TRUST'),
        key: 'money_in_trust',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('COUNTER_PARTY_1'),
        key: 'counterparty_rep_company_1',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('COUNTER_PARTY_2'),
        key: 'counterparty_rep_company_2',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('COUNTER_PARTY_3'),
        key: 'counterparty_rep_company_3',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('BILLING_OFFICE'),
        key: 'billing_office',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PLACE_OF_SUPPLY'),
        key: 'place_of_supply',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('SGST_UTGST_PERCENTAGE'),
        key: 'sgst_utgst_percentage',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('CGST_PERCENTAGE'),
        key: 'cgst_percentage',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('IGST_PERCENTAGE'),
        key: 'igst_percentage',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('CESS_PERCENTAGE'),
        key: 'cess_percentage',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('GST_RATE'),
        key: 'gst_rate',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('INVOICE_FEE_BASIS'),
        key: 'invoice_fee_basis',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('IS_GWS_ENTITY'),
        key: 'is_gws_entity',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('GWS_ENTITY_LOCATION'),
        key: 'gws_entity_location',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PAYMENT_TERMS'),
        key: 'payment_terms',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('PAYMENT_DUE_DATE'),
        key: 'payment_due_date',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('OTHER_INCOME'),
        key: 'other_income',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('SUB_FEE_TYPE'),
        key: 'sub_fee_type',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('INVOICE_HEADER'),
        key: 'invoice_header',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('TOTAL_INVOICE_AMOUNT'),
        key: 'total_invoice_amount',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('SELLER_NAME'),
        key: 'seller_name', 
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('PROPERTY_BASE_ID'),
        key: 'property_base_id',
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('IP_METRO'), 
        key: 'ip_metro', 
        width: 30,
        style: { ...settings.middle }
      },
      {
        header: this.translateService.getTranslation('IS_DATA_CENTER_DEAL'),
        key: 'is_data_center_deal',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('CREATED_BY'),
        key: 'created_by',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('SUBMITTED_BY'),
        key: 'submitted_by',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('APPROVED_BY'),
        key: 'approved_by',
        width: 30,
        style: { ...settings.middle },
      },
      {
        header: this.translateService.getTranslation('CONFIDENTIALITY_STATUS'),
        key: 'confidentiality_status',
        width: 30,
        style: { ...settings.middle },
      },
    ];
  }

  getDataSourceSettings(): ColDef[] {
    return [
      {
        ...fieldIdCol,
        field: 'finishline_id',
        headerName: this.translateService.getTranslation('FINISHLINE_ID'),
      },
      {
        ...fieldInvoiceIdCol,
        field: 'invoice_id',
        headerName: this.translateService.getTranslation('INVOICE_ID'),
        cellRenderer: null,
      },
      {
        ...fieldTransactionTypeCol,
        headerName: this.translateService.getTranslation('TRANSACTION_TYPE'),
      },
      {
        ...fieldDateCol,
        field: 'invoice_date',
        headerName: this.translateService.getTranslation('INVOICE_DT'),
      },
      {
        ...fieldInvoiceTypeCol,
        headerName: this.translateService.getTranslation('INVOICE_TYPE'),
      },
      {
        ...fieldTeamCol,
        headerName: this.translateService.getTranslation('TEAM_ID'),
      },
      {
        ...fieldCurrencyCol,
        headerName: this.translateService.getTranslation('CURRENCY'),
      },
      {
        ...fieldOppNumberCol,
        headerName: this.translateService.getTranslation('OPPORTUNITY_NO'),
      },
      {
        ...fieldOpportunityCol,
        headerName: this.translateService.getTranslation('OPPORTUNITY_ID'),
      },
      {
        ...fieldOpportunityInstallmentCol,
        headerName: this.translateService.getTranslation('OPPORTUNITY_INSTALLMENT_ID'),
      },
      {
        ...fieldOpportunitySourceCol,
        headerName: this.translateService.getTranslation('OPPORTUNITY_SOURCE'),
      },
      {
        ...fieldTransSubtypeCol,
        headerName: this.translateService.getTranslation('TRANSACTION_SUBTYPE'),
      },
      {
        ...fieldExecutionDateCol,
        headerName: this.translateService.getTranslation('EXECUTION_DATE'),
      },
      {
        ...fieldAssetPortfolioTypeCol,
        headerName: this.translateService.getTranslation('ASSET_TYPE'), 
      },
      {
        ...fieldMiqIdCol,
        headerName: this.translateService.getTranslation('MIQ_PROPERTY_ID'),
      },
      {
        ...fieldGridIdCol,
        headerName: this.translateService.getTranslation('PROPERTY_GRID_ID'),
      },
      {
        ...fieldBuildingNameCol,
        headerName: this.translateService.getTranslation('BUILDING_NAME'),
      },
      {
        ...fieldAddressLine1Col,
        headerName: this.translateService.getTranslation('ADDRESS_LINE1'),
      },
      {
        ...fieldAddressLine2Col,
        headerName: this.translateService.getTranslation('ADDRESS_LINE2'),
      },
      {
        ...fieldPostcodeCol,
        headerName: this.translateService.getTranslation('POSTAL_CODE'),
      },
      {
        ...fieldSuburbCol,
        headerName: this.translateService.getTranslation('SUBURB'),
      },
      {
        ...fieldDistrictCol,
        headerName: this.translateService.getTranslation('DISTRICT'),
      },
      {
        ...fieldLocalityCol,
        headerName: this.translateService.getTranslation('LOCALITY'),
      },
      {
        ...fieldRegionCol,
        headerName: this.translateService.getTranslation('REGION'),
      },
      {
        ...fieldCountryCol,
        headerName: this.translateService.getTranslation('COUNTRY'),
      },
      {
        ...fieldAgileSpaceDetailsCol,
        headerName: this.translateService.getTranslation('AGILE_SPACE_DETAILS'),
      },
      {
        ...fieldPropertyTypeCol,
        headerName: this.translateService.getTranslation('PROPERTY_TYPE'),
      },
      {
        ...fieldPropertySubtypeCol,
        headerName: this.translateService.getTranslation('PROPERTY_SUBTYPE'),
      },
      {
        ...fieldPropertyTypeSpaceLabelCol,
        field: 'property_type_space',
        headerName: this.translateService.getTranslation('PROPERTY_TYPE_SPACE'),
      },
      {
        ...fieldPropertyAreaCol,
        headerName: this.translateService.getTranslation('PROPERTY_AREA'),
      },
      {
        ...fieldSizeAreaMeasureCol,
        headerName: this.translateService.getTranslation('SIZE_AREA_MEASURE'),
      },
      {
        ...fieldResidentialUnitsCol,
        headerName: this.translateService.getTranslation('RESIDENTIAL_UNITS'),
      },
      {
        ...fieldRoomsCol,
        headerName: this.translateService.getTranslation('ROOMS'),
      },
      {
        ...fieldLandCol,
        headerName: this.translateService.getTranslation('LAND'),
      },
      {
        ...fieldLandAreaMeasureCol,
        headerName: this.translateService.getTranslation('LAND_AREA_MEASURE'),
      },
      {
        ...fieldPropertyAreaCol,
        field: 'racks',
        headerName: this.translateService.getTranslation('CALCULATION_METRIC_RACKS'),
      },
      {
        ...fieldPropertyAreaCol,
        field: 'megawatts',
        headerName: this.translateService.getTranslation('CALCULATION_METRIC_MEGAWATTS'),
      },
      {
        ...fieldPropertyAreaCol,
        field: 'kilowatts',
        headerName: this.translateService.getTranslation('CALCULATION_METRIC_KILOWATTS'),
      },
      {
        ...fieldCarParkSpacesCol,
        headerName: this.translateService.getTranslation('CAR_SPACES'),
      },
      {
        ...fieldInvestmentProfileCol,
        headerName: this.translateService.getTranslation('INVESTMENT_PROFILE'),
      },
      {
        ...fieldTenureCol,
        headerName: this.translateService.getTranslation('TENURE'),
      },
      {
        ...fieldTenancyCol,
        headerName: this.translateService.getTranslation('TENANCY'),
      },
      {
        ...fieldOccupancyPercentageCol,
        headerName: this.translateService.getTranslation('OCCUPANCY_PERCENTAGE'),
      },
      {
        ...fieldWaleCol,
        headerName: this.translateService.getTranslation('WALE'),
      },
      {
        ...fieldNetOperatingIncomeCol,
        headerName: this.translateService.getTranslation('NET_OPERATING_INCOME'),
      },
      {
        ...fieldPurchasePriceCol,
        headerName: this.translateService.getTranslation('PURCHASE_PRICE').toUpperCase(),
      },
      {
        ...fieldNetYieldCol,
        headerName: this.translateService.getTranslation('NET_YIELD').toUpperCase(),
      },
      {
        ...fieldERVCol,
        headerName: this.translateService.getTranslation('ERV_FULLY_OCCUPIED'),
      },
      {
        ...fieldPropertyManagedCol,
        headerName: this.translateService.getTranslation('MANAGED_BY_CBRE')
      },
      {
        ...fieldPrimaryEmployeeIdCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_ID'),
      },
      {
        ...fieldPrimaryEmployeeNameCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_NAME'),
      },
      {
        ...fieldPrimaryEmployeeFunctionalUnitIdCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_FU_ID'),
      },
      {
        ...fieldPrimaryEmployeeFunctionalUnitCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_FU_DESC'),
      },
      {
        ...fieldPrimaryEmployeeManagingOfficeIdCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_MO_ID'),
      },
      {
        ...fieldPrimaryEmployeeManagingOfficeCol,
        headerName: this.translateService.getTranslation('PRIMARY_EMPLOYEE_MO_DESC'),
      },
      {
        ...fieldRepRolCol,
        headerName: this.translateService.getTranslation('REP_ROLE'),
      },
      {
        ...fieldCustomerIdCol,
        headerName: this.translateService.getTranslation('CUSTOMER_ID'),
      },
      {
        ...fieldCustomerNameCol,
        headerName: this.translateService.getTranslation('CUSTOMER_NAME'),
      },
      {
        ...fieldCompanyTypeCol,
        headerName: this.translateService.getTranslation('COMPANY_TYPE'),
      },
      {
        ...fieldDedicatedClientNameCol,
        headerName: this.translateService.getTranslation('DEDICATED_CLIENT_NAME'),
      },
      {
        ...fieldRepCustVehicleCol,
        headerName: this.translateService.getTranslation('REPRESENTED_FUNDING_VEHICLE'),
      },
      {
        ...fieldRepCustEquityCol,
        headerName: this.translateService.getTranslation('REPRESENTED_EQUITY_SOURCE'),
      },
      {
        ...fieldCounterPartyCol,
        field: 'counter_party_company_name',
        headerName: this.translateService.getTranslation('COUNTER_PARTY_NAME'),
      },
      {
        ...fieldCounterPartyVehicleCol,
        headerName: this.translateService.getTranslation('COUNTER_PARTY_FUNDING_VEHICLE'),
      },
      {
        ...fieldCounterPartyEquityCol,
        headerName: this.translateService.getTranslation('COUNTER_PARTY_EQUITY_SOURCE'),
      },
      {
        ...fieldCustomerIdCol,
        field: 'bill_to_customer_id',
        headerName: this.translateService.getTranslation('CUSTOMER_ID'),
      },
      {
        ...fieldCustomerNameCol,
        field: 'bill_to_customer_name',
        headerName: this.translateService.getTranslation('BILL_TO_CUST'),
      },
      {
        ...fieldCompanyTypeCol,
        field: 'bill_to_company_type',
        headerName: this.translateService.getTranslation('COMPANY_TYPE'),
      },
      {
        ...fieldDedicatedClientNameCol,
        field: 'bill_to_dedicated_client_name',
        headerName: this.translateService.getTranslation('DEDICATED_CLIENT_NAME'),
      },
      {
        ...fieldPurchaseOrderCol,
        headerName: this.translateService.getTranslation('PURCHASE_ORDER'),
      },
      {
        ...fieldMoneyInTrustCol,
        headerName: this.translateService.getTranslation('MONEY_IN_TRUST'),
      },
      {
        ...fieldCounterPartyCol,
        field: 'counterparty_rep_company_1',
        minWidth: 250,
        headerName: this.translateService.getTranslation('COUNTER_PARTY_1'),
      },
      {
        ...fieldCounterPartyCol,
        field: 'counterparty_rep_company_2',
        minWidth: 250,
        headerName: this.translateService.getTranslation('COUNTER_PARTY_2'),
      },
      {
        ...fieldCounterPartyCol,
        field: 'counterparty_rep_company_3',
        minWidth: 250,
        headerName: this.translateService.getTranslation('COUNTER_PARTY_3'),
      },
      {
        ...fieldBillingOfficeCol,
        headerName: this.translateService.getTranslation('BILLING_OFFICE'),
      },
      {
        ...fieldPlaceOfSupplyCol,
        headerName: this.translateService.getTranslation('PLACE_OF_SUPPLY'),
      },
      {
        ...fieldSgstUtgstPercentageCol,
        headerName: this.translateService.getTranslation('SGST_UTGST_PERCENTAGE'),
      },
      {
        ...fieldSgstUtgstPercentageCol,
        field: 'cgst_percentage',
        headerName: this.translateService.getTranslation('CGST_PERCENTAGE'),
      },
      {
        ...fieldSgstUtgstPercentageCol,
        field: 'igst_percentage',
        headerName: this.translateService.getTranslation('IGST_PERCENTAGE'),
      },
      {
        ...fieldSgstUtgstPercentageCol,
        field: 'cess_percentage',
        headerName: this.translateService.getTranslation('CESS_PERCENTAGE'),
      },
      {
        ...fieldGstRateCol,
        headerName: this.translateService.getTranslation('GST_RATE'),
      },
      {
        ...fieldInvoiceFeeBasisCol,
        headerName: this.translateService.getTranslation('INVOICE_FEE_BASIS'),
      },
      {
        ...fieldIsGwsEntityCol,
        headerName: this.translateService.getTranslation('IS_GWS_ENTITY'),
      },
      {
        ...fieldGwsEntityLocationCol,
        headerName: this.translateService.getTranslation('GWS_ENTITY_LOCATION'),
      },
      {
        ...fieldPaymentTermsCol,
        headerName: this.translateService.getTranslation('PAYMENT_TERMS'),
      },
      {
        ...fieldDateCol,
        field: 'payment_due_date',
        headerName: this.translateService.getTranslation('PAYMENT_DUE_DATE'),
      },
      {
        ...fieldOtherIncomeCol,
        headerName: this.translateService.getTranslation('OTHER_INCOME'),
      },
      {
        ...fieldSubFeeTypeCol,
        headerName: this.translateService.getTranslation('SUB_FEE_TYPE'),
      },
      {
        ...fieldInvoiceHeaderCol,
        headerName: this.translateService.getTranslation('INVOICE_HEADER'),
      },
      {
        ...fieldTotalInvoiceAmountCol,
        headerName: this.translateService.getTranslation('TOTAL_INVOICE_AMOUNT'),
      },
      {
        ...fieldSellerNameCol,
        headerName: this.translateService.getTranslation('SELLER_NAME'),
      },
      {
        ...fieldPropertyBaseIdCol,
        headerName: this.translateService.getTranslation('PROPERTY_BASE_ID'),
      },
      {
        ...fieldIpMetroCol,
        headerName: this.translateService.getTranslation('IP_METRO'),
      },
      {
        ...fieldIsDataCenterDealCol,
        headerName: this.translateService.getTranslation('IS_DATA_CENTER_DEAL'),
      },
      {
        ...fieldCreatedByCol,
        headerName: this.translateService.getTranslation('CREATED_BY'),
      },
      {
        ...fieldSubmittedByCol,
        headerName: this.translateService.getTranslation('SUBMITTED_BY'),
      },
      {
        ...fieldApprovedByCol,
        headerName: this.translateService.getTranslation('APPROVED_BY'),
      },
      {
        ...fieldConfidentialityStatusCol,
        headerName: this.translateService.getTranslation('CONFIDENTIALITY_STATUS'),
      },
    ];
  }
}
